module.exports = __webpack_public_path__ + "./images/07bbd00e7d673296eed5c8ceffe68610.jpg";